export const BUTTON_TEXT = {
  LOGIN: 'ĐĂNG NHẬP',
  CONFIRM: 'XÁC NHẬN',
  TRY_AGAIN: 'THỬ LẠI',
  LOGOUT: 'ĐĂNG XUẤT',
  EARNING_COIN: 'TÍCH XU HỘ',
};

export const ID_FIELD = 'id';

export const TYPE_RESPONSE = {
  SUCCESS: 'SUCCESS',
  ERROR_WRONG_QR_CHARACTER: 'SB_QR_ERROR',
  ERROR_QR_USED: 'SB_QR_USED',
  ERROR_QR_NO_EXIST: 'SB_QR_NOEXIST',
  ERROR_QR_INCORRECT: 'SB_QR_UNMATCH',
  ERROR_QR_OUTDATE: 'SB_QR_OUTDATE',
  ERROR_SPOON_USED: 'SB_SPOON_USED',
  ERROR_SPOON_NO_EXIST: 'SB_SPOON_NOEXIST',
  ERROR_SPOON_FORERR: 'SB_SPOON_FORERR',
  ERROR_SPOON_NOT_MATCH_BRAND: 'SB_SPOON_UNMATCH_BRAND',
  ERROR_SPOON_NOT_MATCH_WEIGHT: 'SB_SPOON_UNMATCH_WEIGHT',
  ERROR_SPOON_NOT_MATCH_QR: 'SB_DATE_1722',
  ERROR_SPOON_NOT_MATCH_QR_DATE_AFTER: 'SB_DATE_AFTER722',
  ERROR_EXPIRE: 'SB_EXPIRE',
  ERROR_OVER_ADD_POINT: 'SB_OVERADDPOINT',
  ERROR_ADD_EMPTY: 'SB_ADD_EMPTY',
  ERROR_BLOCK_SAME_QR: 'SB_BLOCK_SAMEQR',
  ERROR_BLOCK_SCAN_QR: 'SB_BLOCK_SCANQR',
  ERROR_ACC_BLOCK_ADD_POINT: 'SB_ACCBLOCK_ADDPOINT',
  ERROR_BLOCK_ADD_POINT: 'SB_BLOCK_ADDPOINT',
  ERROR_QR_NOT_FOUND: 'SB_QR_NOT_FOUND',
  ERROR_SAP_NO_RESPONSE: 'SB_SAP_NORESPONSE',
  ERROR_SYSTEM_OVERLOAD: 'SB_QR_SYSTEM_ERROR',
  ERROR_SYSTEM_MAINTAINING: 'SB_DEFAULT_ERROR',
  ERROR_HOTLINE_USED: 'SB_HOTLINE_SUCCESS',
  ERROR_BLOCKED_ACCOUNT: 'BLOCKED_ACCOUNT',
  ERROR_BLOCKED_ACCOUNT_SAMEQR: 'SB_BLOCK_SAMEQR',
  ERROR_SPOON_CODE_ALREADY_USED_BY_HOTLINE: 'SPOON_CODE_ALREADY_USED_BY_HOTLINE',
  ERROR_BLOCK_IDENTITY_SCAN: 'BLOCK_IDENTITY_SCAN',
  ERROR_SPOON_CMD_NULL: 'SB_SPOON_CMD_NULL',
  ERROR_QR_MANUFACTURE_DATE_MISS: 'SB_QR_MANUFACTURE_DATE_MISS',
  ERROR_QR_EXPIRE_DATE_MISS: 'SB_QR_EXPIRE_DATE_MISS',
  ERROR_SPOON_APPLIED_DATE_MISS: 'SB_SPOON_APPLIED_DATE_MISS',
};

export const TITLE_RESPONSE_TEXT = {
  SUCCESS: 'Tích xu hộ thành công!',
  ERROR_WRONG_QR_CHARACTER: 'Tích xu hộ thất bại!',
  ERROR_QR_USED: 'Tích xu hộ thất bại!',
  ERROR_QR_NO_EXIST: 'Tích xu hộ thất bại!',
  ERROR_QR_INCORRECT: 'Tích xu hộ thất bại!',
  ERROR_QR_OUTDATE: 'Tích xu hộ thất bại!',
  ERROR_SPOON_USED: 'Tích xu hộ thất bại!',
  ERROR_SPOON_NO_EXIST: 'Tích xu hộ thất bại!',
  ERROR_SPOON_FORERR: 'Tích xu hộ thất bại!',
  ERROR_SPOON_NOT_MATCH_BRAND: 'Tích xu hộ thất bại!',
  ERROR_SPOON_NOT_MATCH_WEIGHT: 'Tích xu hộ thất bại!',
  ERROR_SPOON_NOT_MATCH_QR: 'Tích xu hộ thất bại!',
  ERROR_SPOON_NOT_MATCH_QR_DATE_AFTER: 'Tích xu hộ thất bại!',
  ERROR_EXPIRE: 'Tích xu hộ thất bại!',
  ERROR_OVER_ADD_POINT: 'Tích xu hộ thất bại!',
  ERROR_ADD_EMPTY: 'Tích xu hộ thất bại!',
  ERROR_BLOCK_SAME_QR: 'Tích xu hộ thất bại!',
  ERROR_BLOCK_SCAN_QR: 'Tích xu hộ thất bại!',
  ERROR_ACC_BLOCK_ADD_POINT: 'Tích xu hộ thất bại!',
  ERROR_BLOCK_ADD_POINT: 'Tích xu hộ thất bại!',
  ERROR_QR_NOT_FOUND: 'Tích xu hộ thất bại!',
  ERROR_SAP_NO_RESPONSE: 'Tích xu hộ thất bại!',
  ERROR_SYSTEM_OVERLOAD: 'Tích xu hộ thất bại!',
  ERROR_SYSTEM_MAINTAINING: 'Tích xu hộ thất bại!',
  ERROR_HOTLINE_USED: 'Tích xu hộ thất bại!',
  ERROR_BLOCKED_ACCOUNT: 'Tích xu hộ thất bại!',
  ERROR_BLOCKED_ACCOUNT_SAMEQR: 'Tích xu hộ thất bại!',
  ERROR_SPOON_CODE_ALREADY_USED_BY_HOTLINE: 'Tích xu hộ thất bại!',
  ERROR_BLOCK_IDENTITY_SCAN: 'Tích xu hộ thất bại!',
  ERROR_SPOON_CMD_NULL: 'Tích xu hộ thất bại!',
  ERROR_QR_MANUFACTURE_DATE_MISS: 'Tích xu hộ thất bại!',
  ERROR_QR_EXPIRE_DATE_MISS: 'Tích xu hộ thất bại!',
  ERROR_SPOON_APPLIED_DATE_MISS: 'Tích xu hộ thất bại!',
};

export const DESCRIPTION_RESPONSE_TEXT = {
  SUCCESS: <>Bạn đã tích xu thành công cho khách hàng</>,
  ERROR_WRONG_QR_CHARACTER: <>Nhập sai ký tự mã QR</>,
  ERROR_QR_USED: <>Mã QR đã được sử dụng</>,
  ERROR_QR_NO_EXIST: <>Mã muỗng không tồn tại</>,
  ERROR_QR_INCORRECT: <>Mã QR đang được cập nhật</>,
  ERROR_QR_OUTDATE: <span className="font-semibold">Mã QR hết hạn sử dụng</span>,
  ERROR_SPOON_USED: <>Mã muỗng bị lỗi</>,
  ERROR_SPOON_NO_EXIST: <>Mã muỗng không tồn tại</>,
  ERROR_SPOON_FORERR: <>Nhập sai ký tự mã QR</>,
  ERROR_SPOON_NOT_MATCH_BRAND: <>Mã muỗng không đúng sản phẩm</>,
  ERROR_SPOON_NOT_MATCH_WEIGHT: (
    <>
      Mã muỗng <span className="font-semibold">không đúng trọng lượng sản phẩm</span>
    </>
  ),
  ERROR_SPOON_NOT_MATCH_QR: (
    <>
      Mã muỗng{' '}
      <span className="font-semibold">
        không khớp <br />
        với mã QR
      </span>
    </>
  ),
  ERROR_SPOON_NOT_MATCH_QR_DATE_AFTER: (
    <>
      Mã muỗng{' '}
      <span className="font-semibold">
        không khớp <br />
        với mã QR
      </span>
    </>
  ),
  ERROR_EXPIRE: <>Sản phẩm tích xu</>,
  ERROR_OVER_ADD_POINT: <>Bạn đã hết lượt đổi muỗng</>,
  ERROR_ADD_EMPTY: <>Bạn chưa có địa chỉ mặc định</>,
  ERROR_BLOCK_SAME_QR: <>Tính năng tích xu tạm khóa 24h</>,
  ERROR_BLOCK_SCAN_QR: <>Tính năng tích xu tạm khóa 24h</>,
  ERROR_ACC_BLOCK_ADD_POINT: <>Tài khoản đã bị khóa</>,
  ERROR_BLOCK_ADD_POINT: <>Bạn đã hết lượt tích xu</>,
  ERROR_QR_NOT_FOUND: <>Mã QR không hợp lệ</>,
  ERROR_SAP_NO_RESPONSE: <>Gián đoạn dịch vụ</>,
  ERROR_SYSTEM_OVERLOAD: <>Hệ thống đang quá tải</>,
  ERROR_SYSTEM_MAINTAINING: <>Mã muỗng bị lỗi</>,
  ERROR_HOTLINE_USED: <>Mã muỗng đã được sử dụng bởi Hotline</>,
  ERROR_BLOCKED_ACCOUNT: <>Tài khoản đã bị khóa</>,
  ERROR_BLOCKED_ACCOUNT_SAMEQR: (
    <>
      Tài khoản khách hàng <br />
      đã bị khóa!
    </>
  ),
  ERROR_SPOON_CODE_ALREADY_USED_BY_HOTLINE: <>Mã muỗng đã được sử dụng bởi Hotline</>,
  ERROR_BLOCK_IDENTITY_SCAN: <>Tính năng tích xu đang tạm khóa</>,
  ERROR_SPOON_CMD_NULL: <>Mã muỗng không khớp mã QR</>,
  ERROR_QR_MANUFACTURE_DATE_MISS: <>Mã QR đang bị lỗi</>,
  ERROR_QR_EXPIRE_DATE_MISS: <>Mã QR đang bị lỗi</>,
  ERROR_SPOON_APPLIED_DATE_MISS: <>Mã QR đang bị lỗi</>,
};

export const STORAGE_KEY = {
  ACCESS_TOKEN: 'ACCESS_TOKEN',
};

export const CODE_KEY = {
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  ERROR_NETWORK: 'ERROR_NETWORK',
  TIME_OUT: 408,
  UNAUTHORIZED_STATUS: 401,
  NOT_INTERNET: 'NOT_INTERNET',
  UNDEFINED: 'UNDEFINED',
  UNKNOWN: 'UNKNOWN',
};

export const API_METHOD = {
  POST: 'POST',
  GET: 'GET',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export const API_SUCCESS_STATUS = 1000;

export const END_POINT_THIRD_PARTY = '/third-party';

export const CLAIM_TYPES = {
  NAME: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
  ROLE: 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
};
